import {
  POSConfig,
  POSTable,
  POSOrder,
  POSSyncResponse,
  POSPaymentUpdate
} from './types';

/**
 * Abstract base class for all POS integrations
 * Each POS provider must implement these methods
 */
export abstract class POSAdapter {
  protected config: POSConfig;

  constructor(config: POSConfig) {
    this.config = config;
  }

  /**
   * Test connection to POS system
   */
  abstract testConnection(): Promise<boolean>;

  /**
   * Get all tables from POS
   */
  abstract getTables(): Promise<POSTable[]>;

  /**
   * Get specific table by POS table ID
   */
  abstract getTable(posTableId: string): Promise<POSTable | null>;

  /**
   * Get current order for a table
   */
  abstract getTableOrder(posTableId: string): Promise<POSOrder | null>;

  /**
   * Get all open orders
   */
  abstract getOpenOrders(): Promise<POSOrder[]>;

  /**
   * Send payment update to POS (mark items as paid)
   */
  abstract sendPaymentUpdate(payment: POSPaymentUpdate): Promise<POSSyncResponse>;

  /**
   * Close/complete an order in the POS
   */
  abstract closeOrder(orderId: string): Promise<POSSyncResponse>;

  /**
   * Sync specific table data from POS to Firestore
   * This is what gets called when user clicks "Sync"
   */
  abstract syncTable(mesaId: string, posTableId: string): Promise<POSSyncResponse>;

  /**
   * Get provider name
   */
  getProvider(): string {
    return this.config.provider;
  }
}
